export const apiErrorMessage = (error, fallback) => {
  const detail = error.response?.data?.detail;
  return typeof detail === "string" ? detail : fallback;
};

export const trimFields = (fields) => Object.fromEntries(
  Object.entries(fields).map(([key, value]) => [key, value.trim()])
);

export const quoteValidationError = (payload) => {
  if (!payload.name || !payload.contact || !payload.message) {
    return "Remplis ton nom, ton contact et ton message";
  }
  if (payload.request_type === "covoiturage" && (!payload.depart || !payload.arrivee)) {
    return "Indique le départ et l'arrivée du trajet";
  }
  return null;
};

export const reviewValidationError = (name, comment, visitor) => {
  if (!visitor && !name.trim()) return "Indique ton prénom et ton avis";
  if (comment.trim().length < 3) return "Écris ton avis";
  return null;
};